import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Modal,
  Backdrop,
  Fade,
  TextField,
} from "@material-ui/core";
import { useAuth } from "./firebase/AuthContext";

const Password = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const { resetPassword } = useAuth();
  const passwordRef = useRef();
  const history = useHistory();
  const [message, setMessage] = useState("")

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setMessage("")
      setError("")
      setLoading(true)
      await resetPassword(passwordRef.current.value)
      setMessage("Check your inbox for further instructions. Depending on your email provider, please check your spam folder.")
    } catch {
      setError("Failed to reset password")
    }

    setLoading(false)
  }



    return (
      <div>
        <h4 style={{ color: '#7E3AF2', fontFamily: 'Inter', margin:'30px', cursor:'pointer' }} onClick={handleOpen}>
  Reset Password
</h4>


        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div
              style={{
                backgroundColor: "#fff",
                border: "2px solid #000",
                boxShadow:
                  "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
                padding: "32px",
                textAlign: "center",
              }}
            >
              <h2 id="transition-modal-title">Reset Password</h2>
              <h5 style={{color: 'red'}}>{error}</h5>
              <h5 style={{color: 'black'}}>{message}</h5>
              <form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onSubmit={handleSubmit}
              >
                <TextField
                  id="email"
                  label="Email"
                  variant="outlined"
                  style={{ margin: "16px 0", width: "25ch" }}
                  inputRef={passwordRef}
                  placeholder="enter the email address to your account"
                  required
                />
                <Button variant="contained" color="primary" style={{ margin: "16px 0" }} disabled={loading} type="submit">
                Submit
                </Button>
              </form>
            </div>
          </Fade>
        </Modal>
      </div>
    );

};

export default Password;